
import React, {Suspense } from "react";
import Icons from './IconsList';
import SuspenseIconLoader from "./SuspenseIconLoader";


// const FakeIcon = lazy(() =>
// 	new Promise((resolve) => {
// 	  setTimeout(() => {
// 		resolve({ default: () => <DefaultIcon/> }); // Simple icon replacement
// 	  }, 10000); // Simulated delay (3 seconds)
// 	})
//   );

const IconComponent = ({ iconType, ...props }) => {
	const Icon = Icons[iconType];
	const Default=Icons["Lead"];
	return (
	  <Suspense fallback={<SuspenseIconLoader />}>
		{Icon ? <Icon {...props} /> :<Default /> }
		{/* <FakeIcon /> */}
	  </Suspense>
	);
  };
  
  export default IconComponent;
  